import styled from 'styled-components'

export const IconAlert = styled.p`
  font-size: 1em !important;
  color: red;
  display: inline;
  margin-left: 1em;
  margin-right: 0px !important;
`